/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/validationUtil.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/validation-util.js
**/

var ValidationUtil = {};

ValidationUtil = (function() {	
	
	
	function initialize() {
		
		$('#departOnInput').blur(function(){
			correctDateFormat($(this));
		});
		
		$('#returnOnInput').blur(function(){
			correctDateFormat($(this));
		});
	}
	
	var correctDateFormat = function($field) {
		var rawDate = addYearIfAbsent($field.val());
		try {
			var d = $.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), rawDate);
			$field.val($.datepicker.formatDate(AAcom.prototype.getProperty('dateFormat'), d));
		} catch(error) {
			return false;
    	}
		return true;
	};
	
	var addYearIfAbsent = function(d) {
		var ret = d;
		try {
			/* if missing year */
			if(missingYear(d)) {
				var date = $.datepicker.parseDate('mm/dd', d);
				var today = getToday();
				var year = today.getFullYear();
				console.log(date + ' ' + today);
				if(date < today) {
					year = year + 1;
				}
				ret = d + "/" + year;
			}
		} catch(err) {}
		return ret;
		
		function getToday() {
			var date = new Date();
			var today = new Date();
			return new Date(date.getFullYear(), date.getMonth(), date.getDate(),0,0,0,0);
		}
		function missingYear(str) {
			return count(d, "/") == 1;
		}
		function count(str, delim) {
			return str.split(delim).length-1;
		}
	};
	
	
	return {
		initialize : initialize
	};
	
}());
